import React, { useState, useRef, useEffect, useCallback, useImperativeHandle, forwardRef } from 'react';

const TextEditor = forwardRef((props, ref) => {
  const [value, setValue] = useState(() => props.value.value);
  const editorRef = useRef(null);

  const stopNavigation = useCallback(event => {
    if ([32, 37, 38, 39, 40, 36, 35, 9].includes(event.keyCode)) {
      event.stopPropagation();
    }
  }, []);

  const onChange = useCallback(event => {
    setValue(event.target.value);
  }, []);

  useEffect(() => {
    const element = editorRef.current;

    if (!element) return;

    element.addEventListener('keydown', stopNavigation);

    return () => {
      element.removeEventListener('keydown', stopNavigation);
    };
  }, [stopNavigation]);

  useImperativeHandle(
    ref,
    () => ({
      getValue() {
        return { ...props.value, value };
      },
      isPopup() {
        return false;
      },
      afterGuiAttached() {
        setTimeout(() => {
          editorRef.current?.select();
        }, 1);
      },
    }),
    [props.value, value],
  );

  return (
    <span className="control-wrap">
      <input
        ref={editorRef}
        className="form-control input-sm"
        name="applistLabel"
        onChange={onChange}
        placeholder="Approval List"
        type="text"
        value={value}
      />
    </span>
  );
});

export default TextEditor;
